export default __webpack_public_path__ + "static/media/Wechat.7a4aba73.svg";